export default "__VITE_ASSET__fb3f3b61__"